import styled from 'styled-components';

export const TableWrapper = styled.div`
  overflow-x: auto;
  display: ${(props) => (props.hidden === true ? 'none' : 'inline')};
  position: absolute;
  background-color: #fff;
  z-index: 1000;
  left: 0;

  @media (max-width: 700px) {
    & {
      width: 100%;
    }
  }
`;
